// extracted by mini-css-extract-plugin
export default {"content":"style_content__G6sBa","itemName":"style_itemName__Rb2pU"};